import apiCall from "./apiCall";

export default async function postCompleteOnboardingRegistration(token, password, password_confirmation) {
    const URL = process.env.REACT_APP_API_URL+'/api/onboarding/complete-registration';
    const BODY = {token: token, password: password, password_confirmation: password_confirmation};
    const data = await apiCall('POST', URL, BODY);
    return data;
}
